<template>
  <div>
    <b-card style="height:calc(100vh - 275px); overflow-y:auto;">
      <h3>Custom Indicator Settings</h3>

      <b-table :items="customIndicatorsData" :fields="customIndicatorFields">
        <template v-slot:cell(actions)="data">
          <b-form-checkbox
            :disabled="searchPage"
            v-model="data.item.isActiveindicator"
            @input="onCheckIndicator(data)"
          ></b-form-checkbox>
        </template>
        <template v-slot:cell(tp_customatt)="data">
          <p class="text-capitalize">{{data.item.tp_customatt}}</p>
        </template>
        <template v-slot:cell(tp_customatt_values)="data">
          <v-select
            :disabled="searchPage"
            :searchable="true"
            :clearable="true"
            label="tp_values"
            :options="data.item.tp_customatt_values"
          ></v-select>
        </template>
      </b-table>

      <!-- -------------------------------------------------------- -->
      <hr />
      <h3>Score</h3>
      <p class="text-danger">This is not functional</p>

      <b-tabs active-nav-item-class="text-capitalize">
        <b-tab
          v-for="ind in $store.state.priConfigrationforms.customIndicationsSettings.customIndicatorsTabs"
          :key="ind.item.id"
          :title="ind.item.tp_customatt"
        >
          <b-table-simple class="table">
            <b-thead>
              <b-tr>
                <b-th scope="col">Risk</b-th>
                <b-th scope="col">From</b-th>
                <b-th scope="col">To</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr>
                <b-td>
                  <b-badge variant="success">Low</b-badge>
                </b-td>
                <b-td>1</b-td>
                <b-td>
                  <b-form-input
                    :disabled="searchPage"
                    v-model="ind.lowerUpperLimit"
                    onkeydown="return event.keyCode !== 69"
                    type="number"
                    max="30"
                  ></b-form-input>
                </b-td>
              </b-tr>

              <b-tr>
                <b-td>
                  <b-badge variant="warning">Medium</b-badge>
                </b-td>
                <b-td>{{ind.lowerUpperLimit ? parseInt(ind.lowerUpperLimit)+1 : 0}}</b-td>
                <b-td>
                  <b-form-input
                    :disabled="searchPage"
                    onkeydown="return event.keyCode !== 69"
                    type="number"
                    min="31"
                    max="75"
                    v-model="ind.mediumUpperLimit"
                  ></b-form-input>
                </b-td>
              </b-tr>
              <b-tr>
                <b-td>
                  <b-badge variant="danger">High</b-badge>
                </b-td>
                <b-td>{{ind.mediumUpperLimit ? parseInt(ind.mediumUpperLimit)+1 : 0}}</b-td>
                <b-td>100</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import { HTTP } from "../../../utils/HTTP";
export default {
  name: "CustomIndicatorsComponent",
  data() {
    return {
      customIndicatorFields: [
        {
          key: "tp_customatt",
          label: "Indicator"
        },
        {
          key: "actions",
          label: "Actions"
        }
      ]
    };
  },
  mounted() {},
  methods: {
    onCheckIndicator(e) {
      let index = this.$store.state.priConfigrationforms.customIndicationsSettings.customIndicatorsTabs.findIndex(
        x => x.item.id == e.item.id
      );
      if (index == -1) {
        let data = {
          item: e.item,
          lowerUpperLimit: 30,
          mediumUpperLimit: 75
        };
        this.$store.state.priConfigrationforms.customIndicationsSettings.customIndicatorsTabs.push(
          data
        );
      } else {
        this.$store.state.priConfigrationforms.customIndicationsSettings.customIndicatorsTabs.splice(
          index,
          1
        );
      }
    }
  },
  props: {
    customIndicatorsData: Array,
    searchPage: Boolean
  }
};
</script>